import { useEffect, useState } from 'react';
import { userApi } from '../../api/user.api';
import { BASE_MEDIA_URL } from '../../api/client';
import { useUI } from '../../store/UIContext';
import { PageHeader, Btn, DraftTextarea } from '../../components/ui/index';
import SignaturePad from '../../components/settings/SignaturePad';

export default function SignaturePage() {
  const { addToast } = useUI();
  const [signatureText, setSignatureText] = useState('');
  const [textSeed, setTextSeed] = useState(0);
  const [imageData, setImageData] = useState(null);
  const [savedPreviewUrl, setSavedPreviewUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    userApi.getSignature()
      .then((r) => {
        const data = r.data || {};
        if (data.signature_text) {
          setSignatureText(data.signature_text);
          setTextSeed((n) => n + 1);
        }
        if (data.file_name) {
          setSavedPreviewUrl(`${BASE_MEDIA_URL}${data.file_name}`);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const save = async () => {
    if (!imageData && !savedPreviewUrl) {
      addToast('ابتدا امضای تصویری را رسم کنید', 'error');
      return;
    }
    setSaving(true);
    try {
      const payload = { signature: signatureText || undefined };
      if (imageData) payload.image_data = imageData;
      const res = await userApi.sendSignature(payload);
      const fileName = res.data?.file_name;
      if (fileName) setSavedPreviewUrl(`${BASE_MEDIA_URL}${fileName}`);
      addToast('امضا ذخیره شد', 'success');
    } catch {
      addToast('خطا در ذخیره امضا', 'error');
    }
    setSaving(false);
  };

  const previewUrl = imageData || savedPreviewUrl;

  return (
    <div className="fade-in">
      <PageHeader
        title="امضای تصویری"
        subtitle="امضای رسم‌شده در فرم‌های چاپ گزارش روزانه و ماموریت نمایش داده می‌شود"
      />
      <div style={{
        maxWidth: 560,
        background: '#fff',
        borderRadius: 16,
        border: '1px solid rgba(35,58,122,0.1)',
        padding: 32,
        boxShadow: '0 4px 16px rgba(35,58,122,0.08)',
      }}>
        {loading ? (
          <p style={{ fontSize: 13, color: '#94a3b8' }}>در حال بارگذاری...</p>
        ) : (
          <>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#64748b', marginBottom: 8 }}>
              رسم امضا
            </label>
            <SignaturePad
              initialDataUrl={savedPreviewUrl}
              onChange={setImageData}
            />

            <div style={{ marginTop: 20 }}>
              <DraftTextarea
                draftKey="user_signature_text"
                label="متن تکمیلی (اختیاری)"
                rows={3}
                placeholder="با احترام&#10;نام شما"
                insertText={signatureText}
                insertNonce={textSeed || undefined}
                onChange={setSignatureText}
              />
            </div>

            {previewUrl && (
              <div style={{ marginTop: 16, padding: 16, background: '#f8faff', borderRadius: 8, border: '1px solid #e2e8f0' }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: '#64748b', marginBottom: 8 }}>پیش‌نمایش امضای ذخیره‌شده:</div>
                <img
                  src={previewUrl}
                  alt="امضا"
                  style={{ maxWidth: '100%', maxHeight: 100, objectFit: 'contain', display: 'block' }}
                />
                {signatureText && (
                  <p style={{ fontSize: 12, color: '#475569', whiteSpace: 'pre-wrap', margin: '10px 0 0' }}>{signatureText}</p>
                )}
              </div>
            )}

            <Btn onClick={save} loading={saving} style={{ marginTop: 16 }}>
              ذخیره امضا
            </Btn>
          </>
        )}
      </div>
    </div>
  );
}
